import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52')
];

export const server_loads = [];

export const dictionary = {
		"/(default)": [24],
		"/(default)/about/changelog": [~25,[2,3]],
		"/(default)/about/faq": [26,[2,4]],
		"/(default)/about/feedback": [27,[2,5]],
		"/(default)/about/feedback/thank-you": [28,[2,5]],
		"/(default)/about/privacy": [29,[2,6]],
		"/(default)/about/terms": [30,[2,7]],
		"/(default)/collections/automations": [31,[8,9]],
		"/(default)/collections/automations/[automationId]": [32,[8,9]],
		"/(default)/collections/chats": [33,[8,10]],
		"/(default)/collections/chats/shared/[shareId]": [~37,[8,10,13,14]],
		"/(default)/collections/chats/[chatId]": [34,[8,10,11]],
		"/(default)/collections/chats/[chatId]/interactions/[interactionId]": [35,[8,10,11]],
		"/(default)/collections/chats/[chatId]/settings": [36,[8,10,11,12]],
		"/(default)/collections/context": [38,[8,15]],
		"/(default)/collections/memories": [39,[8,16]],
		"/(default)/collections/prompts": [40,[8,17]],
		"/(default)/collections/prompts/new": [42,[8,17]],
		"/(default)/collections/prompts/[promptId]": [41,[8,17]],
		"/(default)/collections/providers": [43,[8,18]],
		"/(default)/collections/providers/new": [45,[8,18]],
		"/(default)/collections/providers/[providerId]": [44,[8,18]],
		"/(default)/collections/tools": [46,[8,19]],
		"/(default)/collections/tools/[toolId]": [47,[8,19]],
		"/(default)/dev/ai-sdk": [48],
		"/(default)/dev/error": [49],
		"/(default)/settings/appearance": [50,[20,21]],
		"/(default)/settings/data": [51,[20,22]],
		"/(default)/settings/profile": [52,[20,23]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';